<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p><strong>COGAA</strong> by ABC Strategie.</p>
    </div>
  </footer>
</template>

<script>
/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */

export default {
  name: 'TheHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/TheFooter.vue